/**
 * アコーディオン
 * .accordion__trgをクリックで#hogeに対して.accordion--openが追加されます
 * ex) pugの記述例
 * .accordion__trg(accordion-target="#hoge")
 * #hoge
 */
export default function () {
  const toggleAccordion = (event) => {
    const trg = event.target;
    const targetSelector = trg.getAttribute('accordion-target');
    const target = document.querySelector(targetSelector);
    if (!target) return;
    trg.classList.toggle('accordion--open')
    target.classList.toggle('accordion--open')
  }
  const accordion__trgs = document.getElementsByClassName('accordion__trg');
  for (const accordion__trg of accordion__trgs) {
    accordion__trg.addEventListener('click', toggleAccordion)
  }
}
